import axiosInstance from "services/axiosMiddleware";

export async function deActivate(data){
     try {
        console.log('data',data)
        const response = await axiosInstance.post('coupon/updateCouponStatus', data );
       console.log('response',response)
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
}